import { TrackingEvent } from 'client/tracking/event';
import { TrackingConstant } from 'client/tracking/constant';

export const EngineTypeQuizMap = {
  submit_ev_quiz_survey: TrackingEvent.actionCompleted(TrackingConstant.ENGAGE_SURVEY, 'submit_ev_quiz_survey'),
  ev_quiz_survey_yes_comments: TrackingEvent.actionCompleted(
    TrackingConstant.ENGAGE_SURVEY,
    'ev_quiz_survey_yes_comments'
  ),
  ev_quiz_survey_no_comments: TrackingEvent.actionCompleted(
    TrackingConstant.ENGAGE_SURVEY,
    'ev_quiz_survey_no_comments'
  ),
  shop_my_matches: TrackingEvent.actionCompleted(TrackingConstant.VIEW_SEARCH_RESULT, 'shop_my_matches'),
};
